module.exports = __webpack_public_path__ + "static/01-21b5db95493dc210eef97ab2f2c16afd.jpg";